module.exports = {
  getDeliveryStatus: async ({ commit, dispatch }, id) => {
    if (!id) return null

    const config = {
      method: 'get',
      url: `orders/${id}/delivery`,
    }

    const response = await dispatch('sendRequest', config, { root: true })
    if (response.status === 'ok') {
      commit('order/setDeliveryStatus', response.data, { root: true })
      return null
    } else {
      return response.message
    }
  },
  createGroupOrder: async ({ commit, dispatch }, data) => {
    const config = {
      method: 'post',
      url: 'carts/group',
      data,
    }

    const response = await dispatch('sendRequest', config, { root: true })

    if (response.status === 'ok') {
      commit('setCart', response.data.cart, { root: true })
      delete response.data.cart
      response.data.name = response.data.hostfullname
      commit('setGroupOrder', response.data, { root: true })
      return response
    } else {
      return response // Return error data
    }
  },
  getGroupOrder: async ({ commit, dispatch }, orderId) => {
    const config = {
      method: 'get',
      url: `carts/group/${orderId}`,
    }

    const response = await dispatch('sendRequest', config, { root: true })

    if (response.status === 'ok') {
      return response.data
    } else {
      commit('setErrors', response.message, { root: true })
      return null
    }
  },
  joinGroupOrder: async ({ commit, dispatch }, { orderId, name }) => {
    const config = {
      method: 'put',
      url: `carts/group/${orderId}/join`,
      data: {
        accept_invite: true,
        participant_name: name,
      },
    }

    const response = await dispatch('sendRequest', config, { root: true })

    if (response.status === 'ok') {
      return response.data
    } else {
      commit('setErrors', response.message, { root: true })
    }
  },
  leaveGroupOrder: async ({ commit, dispatch }, orderId) => {
    const config = {
      method: 'post',
      url: `carts/group/${orderId}/cancel`,
    }

    const response = await dispatch('sendRequest', config, { root: true })

    if (response.status === 'ok') {
      return response.data
    } else {
      commit('setErrors', response.message, { root: true })
    }
  },
  validateGroupOrder: async ({ rootState, commit, dispatch }, orderId) => {
    const config = {
      method: 'post',
      url: `carts/group/${orderId}/validate`,
    }

    const response = await dispatch('sendRequest', config, { root: true })

    if (response.status === 'ok') {
      return response.data
    } else {
      // commit('setErrors', response.message, { root: true }) // Default error is not descriptive
      if (rootState.custom_dig.groupOrder && rootState.custom_dig.groupOrder.participants && rootState.custom_dig.groupOrder.participants.length === 1) {
        // Group order only has host as a participant
        commit('setErrors', 'Group orders must have at least 2 pariticipants, please invite some friends to continue.', { root: true })
      } else {
        // Not all participants have submitted their orders
        commit('setErrors', 'All participants of your group order must submit their basket before the host does.', { root: true })
      }
    }
  },
  submitGroupOrder: async ({ commit, dispatch }, orderId) => {
    // Submits when host submits their basket
    const config = {
      method: 'post',
      url: `carts/group/${orderId}/submit`,
      headers: {
        verify: true,
      },
    }

    const response = await dispatch('sendRequest', config, { root: true })

    if (response.status === 'ok') {
      return response.data
    } else {
      commit('setErrors', response.message, { root: true })
    }
  },
}
